import { useRouter } from 'next/router';
import { t } from 'i18next';
// configs
import { DISABLED_POS_WPP_AR, DISABLED_POS_WPP_CO, DISABLED_POS_WPP_MX } from 'config/flags';
// components
import { MessageWrapper } from '@commons/components/MessageWrapper';
// utisl && hooks
import { useUser } from 'utils/hooks';
import { AccessStatusIdEnum } from 'utils/enums';
// styles
import styles from './DisabledPosAlert.module.css';

const DisabledPosAlert = () => {
    const { user, userLocaleCountryCode } = useUser({});
    const {
        query: { posId },
    } = useRouter();
    const pos: any = user?.pointsOfSale?.find((pos) => pos?.id === +posId);

    return (
        <MessageWrapper
            customStyles={{
                border: '1px solid var(--Semantic-Error-100, #F8CBCB)',
                background: 'var(--Semantic-Error-50, #FFEBEB)',
                boxShadow: '0px 10px 15px -3px rgba(64, 67, 91, 0.10), 0px 4px 6px -2px rgba(64, 67, 91, 0.05)',
                height: 70,
            }}
        >
            <div className={styles['wrapper-principal-content']}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16C13 15.7167 12.9042 15.4792 12.7125 15.2875C12.5208 15.0958 12.2833 15 12 15C11.7167 15 11.4792 15.0958 11.2875 15.2875C11.0958 15.4792 11 15.7167 11 16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17ZM12 13C12.2833 13 12.5208 12.9042 12.7125 12.7125C12.9042 12.5208 13 12.2833 13 12V8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8V12C11 12.2833 11.0958 12.5208 11.2875 12.7125C11.4792 12.9042 11.7167 13 12 13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
                        fill="#E22E2E"
                    />
                </svg>

                <div className={styles['messageContent']}>
                    <p className={styles['title']}>
                        {pos.access_status_id === AccessStatusIdEnum.DisabledNonPayment
                            ? 'Punto de venta deshabilitado por falta de pago.'
                            : 'Punto de venta deshabilitado'}
                    </p>
                    <p className={styles['subtitle']}>
                        Tu acceso a la comparativa fue deshabilitado. Para continuar usando la plataforma, contactate
                        con un asesor.
                    </p>
                </div>
            </div>

            <div className={styles['actions']}>
                <a
                    className={styles['assistantBtn']}
                    href={`https://wa.me/${
                        userLocaleCountryCode === 'AR'
                            ? DISABLED_POS_WPP_AR
                            : userLocaleCountryCode === 'MX'
                            ? DISABLED_POS_WPP_MX
                            : DISABLED_POS_WPP_CO
                    }?text=${encodeURIComponent('INICIANDO CHAT CON EXTENDEAL')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {}}
                    style={{ textDecoration: 'none' }}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        style={{ marginBottom: 1 }}
                    >
                        <path
                            d="M8.03353 0C3.64259 0 0.0684557 3.55648 0.0665929 7.9277C0.0661272 9.32499 0.433087 10.6889 1.13022 11.8911L0 16L4.2233 14.8975C5.38704 15.5291 6.69701 15.8619 8.03027 15.8624H8.03353C12.424 15.8624 15.9981 12.3054 16 7.93419C16.0009 5.81578 15.1729 3.82389 13.6688 2.32557C12.1646 0.826787 10.1645 0.000926892 8.03353 0ZM8.03353 14.5235H8.03074C6.84277 14.5235 5.67716 14.2051 4.66057 13.6049L4.41888 13.4622L1.91303 14.1166L2.58176 11.6849L2.42436 11.4355C1.76169 10.3863 1.41149 9.17344 1.41196 7.92863C1.41335 4.29522 4.38396 1.33936 8.03632 1.33936C9.805 1.33982 11.4675 2.02618 12.7174 3.27193C13.9678 4.51721 14.6556 6.1731 14.6551 7.93373C14.6537 11.5671 11.6831 14.5235 8.03353 14.5235ZM11.6654 9.58823C11.4666 9.48905 10.4877 9.00985 10.3051 8.94358C10.1226 8.8773 9.98987 8.8444 9.85715 9.04275C9.72443 9.24111 9.34304 9.68741 9.22708 9.81949C9.11112 9.95203 8.9947 9.96825 8.79586 9.86908C8.59701 9.7699 7.95529 9.56042 7.1953 8.88564C6.60341 8.36056 6.20385 7.71174 6.0879 7.51338C5.97194 7.31503 6.07533 7.20797 6.17545 7.10926C6.26486 7.02074 6.37429 6.878 6.47395 6.76214C6.57361 6.64628 6.60667 6.56378 6.6728 6.43124C6.73892 6.29915 6.70586 6.18329 6.65603 6.08412C6.6062 5.98494 6.20805 5.00985 6.04226 4.61314C5.88067 4.22709 5.71675 4.27899 5.59427 4.27297C5.47832 4.26694 5.3456 4.26602 5.21288 4.26602C5.08016 4.26602 4.86454 4.31561 4.682 4.51396C4.49945 4.71232 3.98533 5.19152 3.98533 6.16661C3.98533 7.1417 4.69876 8.08388 4.79795 8.21597C4.89761 8.34805 6.20152 10.3492 8.19838 11.207C8.67338 11.411 9.04407 11.5328 9.33326 11.6241C9.81012 11.7748 10.2441 11.7534 10.5869 11.7025C10.9692 11.6455 11.7646 11.2233 11.9304 10.7603C12.0962 10.2978 12.0962 9.90106 12.0463 9.8181C11.9965 9.73561 11.8638 9.68602 11.6649 9.58684L11.6654 9.58823Z"
                            fill="#07AD4B"
                        />
                    </svg>
                    <p className={styles['text-wpp']}>{t('home.timerTrial.text.wpp')}</p>
                </a>
            </div>
        </MessageWrapper>
    );
};

export default DisabledPosAlert;
